import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-mous', templateUrl: './mous.component.html', styleUrls: ['./mous.component.scss'] })
export class MousComponent implements OnInit { constructor() { } ngOnInit(): void { } }
